import { PERMISSIONS_VIEWS } from "config/userPermissions";
import AppointmentManualLoadingForm from "../components/AppointmentManualLoadingForm/AppointmentManualLoadingForm";
import Appointments, { AppointmentSchedules } from "../components/AppointmentSchedules/AppointmentSchedules";
import { AppointmentSchedulesEmpleabilidad } from "../components/AppointmentSchedulesEmpleabilidad/AppointmentSchedulesEmpleabilidad";
import AppointmentManualLoadingFormEmpleabilidad from "../components/AppointmentManualLoadingFormEmpleabilidad/AppointmentManualLoadingFormEmpleabilidad";

export const STEPS_DESCRIPTION = [
    "Detalles de asesoría",
    "Ubicación y público", 
    "Vista previa y confirmación"
];
export const TOAST_MUST_CORRECT_MSG = {
    INVALID_OR_INCOMPLETED: "Te faltan completar campos o existen campos inválidos.",
    TIME_CROSSING: "El horario de asesoría para el asesor seleccionado genera cruces."
};
const { ASESORIAS } = PERMISSIONS_VIEWS;
export const APPOINTMENT_MODULES = [
    { 
        id: ASESORIAS.ACCESO_ASESORIAS,
        path: "", 
        View: Appointments 
    },
    { 
        id: ASESORIAS.HORARIOS_ASESORIAS, 
        path: "psicologicas", 
        View: AppointmentSchedules 
    },
    { 
        id: ASESORIAS.HORARIOS_EMPLEABILIDAD,
        path: "empleabilidad", 
        View: AppointmentSchedulesEmpleabilidad 
    },
    { 
        id: ASESORIAS.CREAR_ASESORIAS, 
        path: "psicologicas/crear", 
        View: AppointmentManualLoadingForm
    },
    { 
        id: ASESORIAS.CREAR_EMPLEABILIDAD,
        path: "empleabilidad/crear", 
        View: AppointmentManualLoadingFormEmpleabilidad
    }
];
